namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PoPurInvoiceDtEditor extends Serenity.Extensions.GridEditorBase<PsTaxInvoiceDtRow> {
        protected getColumnsKey() { return "PosShift.PsTaxInvoiceDt"; }
        protected getDialogType() { return PsTaxInvoiceDtDialog; }
        protected getLocalTextPrefix() { return PsTaxInvoiceDtRow.localTextPrefix; }

        public qnNo: number;

        public myPassValue: string;
        public supid: string;
        public totalamt: number;
        public shopid: string;


        public whsid: string;
        public sumaloamt: number;

        public salevattype: string;
        public doctype: number;

        private _sup: string;
        private _vathd: number;
        private _round: number;
        private _lastV: number;
        private _CallPR: string;
        private _totalsdiff: number;



        constructor(container: JQuery) {
            super(container);

        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)


            buttons.push(
                {
                    title: Q.text("Refresh"),	// *** Get button text from translation
                    cssClass: 'button-refresh',
                    icon: 'fa-refresh',
                    onClick: () => {

                        this.refresh();
                    },
                }
            );



            return buttons;
        }
        public DisableAddButton() {
            this.toolbar.findButton('add-button').toggleClass('disabled', true);
            Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
        }





        protected createSlickGrid() {
            var grid = super.createSlickGrid();


            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('Qty'),
                    new Slick.Aggregators.Sum('BeforeDiscAmt'),
                    new Slick.Aggregators.Sum('DiscAmt'),
                    new Slick.Aggregators.Sum('AlocalteDiscAmt'),
                    new Slick.Aggregators.Sum('ItemExVat'),
                    new Slick.Aggregators.Sum('ItemVatAmt'),
                    new Slick.Aggregators.Sum('ItemNetSales'),
                    new Slick.Aggregators.Sum('ItemExVatAmt'),
                    new Slick.Aggregators.Sum('ItemVatAmt2'),
                    new Slick.Aggregators.Sum('ItemNetSales2'),
                    new Slick.Aggregators.Sum('ExPrice')
                ]
            });
            return grid;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            // opt.frozenColumn = 1;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }



        public get CallPR(): string { return this._CallPR; }

        public get sup(): string { return this._sup; }
        set sup(value: string) {
            if (this._sup != value) {
                console.log("whsid: " + value);
                //  var row =  this.view.getRows();
                this.clearDataGrid();
                this.refresh();
            }
        }

        public get vathd(): number { return this._vathd; }
        set vathd(value: number) {
            // if (this._vathd != value) {
                this._vathd = Number(value.toFixed(2));
            console.log("vathd: " + value);
            //  var row =  this.view.getRows();                
            //     this.refresh();
            // }
        }

        public get round(): number { return this._round; }
        set round(value: number) {
            // if (this._round != value) {
                this._round = Number(value.toFixed(2));
            console.log("round: " + value);
            //     //  var row =  this.view.getRows();                
            //     this.refresh();
            // }
        }

        public get lastV(): number { return this._lastV; }
        set lastV(value: number) {
            this.lastV = value
            console.log("lastV: " + value);
            //     //  var row =  this.view.getRows();                
            //     this.refresh();
            // }
        }

        // public totalsdiff(): number { return this._totalsdiff; }
        public totalsdiff(value: number) {
            // if (this._totalsdiff != value) {
                //this.salevattype = value
                var rows = this.view.getRows();
                var lists = rows.filter(o => o.VatType == "V" && o.ItemNetSales != 0);
                var lineItemNos = lists.map(o => o.LineItemNo);
                var maxLineItemNo = Math.max.apply(Math, lineItemNos.map(function (o) { return o; })) || 0

                var rowa = rows.filter(o => o.LineItemNo == maxLineItemNo);

                for (var po of rowa) {
                    // i++;
                    console.log(po.ItemVatAmt2 + "  " + po.ItemNetSales2)
                    // if (iu.lineItemNos == this._lastV) {
                    var vat = this.roundToTwoDecimals(po.ItemVatAmt2) - this._totalsdiff
                    var exvat = this.roundToTwoDecimals(po.ItemNetSales2) + this._totalsdiff


                    var id = po[this.getIdProperty()]
                    var item = this.view?.getItemById?.(id)
                    if (item) {
                        item.ItemVatAmt2 = vat;
                        item.ItemNetSales2 = exvat;
                        this.view.updateItem(id, item)

                    }
                    // }
                


                }
                this.refresh();
            // }
        }


        set CallPR(value: string) {
            if (this._CallPR != value) {
                var firstChar = (value || '').charAt(0);
                if (firstChar === '1') {
                    this.applyCallPRFromRows(
                        LookupPostrandtsaleRow.getLookup().items.filter(x => x.DocNo === value && x.LineItemType === "10")
                    );
                } else if (firstChar === '2') {
                    // โหลดเฉพาะคอลัมน์ที่ใช้ + จำกัดแถว ลด payload ให้เร็วขึ้น
                    Q.serviceRequest<Serenity.ListResponse<PosTranDtRow>>('PosShift/PosTranDt/ListByDocNo', {
                        DocNo: value
                    }, (response) => {
                        this.applyCallPRFromRows(response.Entities || []);
                    });
                }
                this._CallPR = value;
            }
        }

        private applyCallPRFromRows(row: any[]): void {
                var roundsum = 0;
                var roundvatsum = 0;
                this.clearDataGrid();
                var a = row.length;
                console.log(this._vathd + "  this riu" + this._round);
                var i = 0;
                for (var po of row) {
                    // if(po.LineItemType =="10"){
                    i++;
                    var round = 0;
                    var roundvat = 0;
                    round = this.roundToTwoDecimals(po.ItemNetSales - po.ItemVat)
                    roundvat = this.roundToTwoDecimals(po.ItemVat)

                    roundsum = this.roundToTwoDecimals(roundsum) + this.roundToTwoDecimals(round)
                    roundvatsum = this.roundToTwoDecimals(roundvatsum) + this.roundToTwoDecimals(roundvat)

                    console.log("rounsun" +roundsum+" rvat "+roundvatsum)
                    console.log("r:"+round+" v: "+roundvat)

                    if (po.ItemVatType == "V") {
                        if (roundsum != this._round && a == i && po.ItemVatType == "V") {
                            round = round - (roundsum - this._round)
                            roundsum = roundsum - (roundsum - this._round)
                        }                         
                        else { round = round }

                        if (roundvatsum != this._vathd && a == i && po.ItemVatType == "V") {
                            roundvat = roundvat - (roundvatsum - this._vathd)
                            roundvatsum = roundvatsum - (roundvatsum - this._vathd)
                            console.log(a)
                        } else { roundvat = roundvat }
                    }

                    var unitsell = Q.tryFirst(Product.CsPluRow.getLookup().items, x => x.PluCode == po.PluCode ).SellUnit


                    var item = <PsTaxInvoiceDtRow>{
                        LineItemNo: po.LineItemNo
                        , SalesVatType: this.salevattype ?? "I"
                        , DocType: this.doctype ?? 0
                        , PluCode: po.PluCode
                        , ItemDescription: po.ItemDesc
                        , SerialNo: po.SerialNo
                        , Qty: po.Qty
                        , SellUnit: unitsell ?? "EA"
                        , UnitPrice: po.UnitPrice
                        , ExPrice: po.ExPrice
                        , ItemDiscount: po.ItemDiscount
                        , ItemCharge: po.ItemCharge

                        , ItemNetExprice: po.ItemNetExprice
                        , AllocatedBillDiscount: po.AllocatedBillDiscount
                        , AllocatedBillDiscountVat: po.AllocatedBillDiscountVat
                        , ItemNetSales: po.ItemNetSales
                        , ItemNetSales2: Number(round.toFixed(2))
                        , VatType: po.ItemVatType
                        , VatRate: po.ItemVatRate
                        , ItemVatAmt: po.ItemVat
                        , ItemVatAmt2: Number(roundvat.toFixed(2))

                        , ItemExVat: po.ItemNetSales - po.ItemVat
                        , ItemPromoFg: po.ItemPromoFg ?? 0
                    };

                    var id = this.getNextId();
                    //console.log("get id: " + this.getIdProperty());
                    item[this.getIdProperty()] = id;
                    this.view.addItem(item);
                }
                
                this._totalsdiff = this.roundToTwoDecimals(roundvatsum - this._vathd);
                // 0.01999999999998181  r 779.9100000000001   hd779.89
                console.log(this._totalsdiff + "r " + roundvatsum + " hd" + this._vathd)
                if (this._totalsdiff != 0) {
                    this.totalsdiff(this._totalsdiff)
                } else {

                }

                this.refresh();
        }

        public clearDataGrid() {
            this.view.setItems([], true);
        }

        public roundToTwoDecimals(value: number): number {
            return Math.round((value + Number.EPSILON) * 100) / 100;
        }


    }
}

